import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Logo_sidebar_nav from "assets/Logo_sidebar_nav.png";
import long_logo_sidebar_nav from "assets/long_logo_sidebar_nav.png";
import moon from "assets/moon.png";
import sun from "assets/sun.png";
import { getCookie } from "services/session/cookies";
import { SidebarNav } from "../SidebarNav/SidebarNav";
import { MainMenu } from "utils/constants/SibarBarMenu";
import { setCookie } from "services/session/cookies";
import { ChangeNavigation } from "store/actions/common";
import { useDispatch } from "react-redux";

const SidebarNavigation = ({
  setSideNavigationShow,
  sideNavigationShow,
  ThemeColor,
  changeThemeColor,
}) => {
  const permissions = getCookie("permissions" ? "permissions" : []);
  const dispatch = useDispatch()
  useEffect(() => {
    const sideBar = document.getElementsByClassName("side-navbar")[0];
    if (sideNavigationShow) {
      sideBar.classList.add("width-250");
    } else {
      sideBar.classList.add("w-0");
    }
  }, [sideNavigationShow]);

  const handleNavigation = (key) => {
    const selectedItem = MainMenu.find((item) => item.key === key);
    if (selectedItem) {
      const { label, link, items } = selectedItem;
      const mappedItems = items
        ? items.map((item) => ({
          label: item.label,
          value: item.link,
          permission: item.permission,
        }))
        : [];
      let result = [{ label, value: link }];
      if (mappedItems.length > 0 && permissions.length > 0) {
        const checkPermissions = mappedItems.filter((item) => {
          return JSON.parse(permissions).includes(item.permission);
        });
        result = result.concat(checkPermissions);
      } else {
        result = result.concat(mappedItems);
      }
      setCookie("navItems", JSON.stringify(result));
      dispatch(
        ChangeNavigation(
          result
        )
      )
    }
  };

  const toggleThemeColor = (isLightMode) => {
    changeThemeColor(isLightMode);
    if (isLightMode === true) {
      localStorage.setItem("ThemeColor", "light");
    } else {
      localStorage.setItem("ThemeColor", "dark");
    }
  };

  return (
    <div className="absolute w-full h-full">
      <div
        className="fixed top-0 bottom-0 left-0 right-0 w-full z-700 modal-container-overlay"
        onClick={() => {
          setSideNavigationShow(!sideNavigationShow);
        }}
      ></div>
      <div className="fixed top-0 z-800 bg-black h-full text-white side-navbar flex flex-col justify-between">
        <div>
          <div
            className="mb-6 mt-4 pl-4"
            onClick={() => handleNavigation("A01")}
          >
            <Link
              to="/main-dashboard"
              className="sidebar_logo flex items-center"
            >
              <img src={Logo_sidebar_nav} alt="logo" className="mr-3 h-11" />
              <img
                src={long_logo_sidebar_nav}
                alt="long_logo_sidebar_nav"
                className="h-5"
              />
            </Link>
          </div>
          <SidebarNav
            className="dashboard_nav"
            items={MainMenu}
            handleNavigation={handleNavigation}
          />
        </div>
        <div className="mb-8 ">
          <hr className="h-px my-8 bg-gray-200 border-0 dark:bg-gray-700" />

          <div className="flex items-center bg-[##111F2C] mt-4 ml-5">
            <div className="w-4/5 h-7 flex items-center rounded-full p-1 bg-[#111F2C] ">
              <span className="relative  text-white p-1 flex items-center w-full ">
                <div className="flex items-center mr-4 cursor-pointer">
                  <img src={sun} alt="Sun Icon" className="h-4 w-4 mr-1" />
                  <p
                    className="text-sm hover:text-blue-600"
                    onClick={() => toggleThemeColor(true)}
                  >
                    Light Mode
                  </p>
                </div>

                <div className="flex items-center cursor-pointer">
                  <img src={moon} alt="Moon Icon" className="h-4 w-4 mr-1" />
                  <p
                    className="text-sm hover:text-blue-600"
                    onClick={() => toggleThemeColor(false)}
                  >
                    Dark Mode
                  </p>
                </div>
                <span
                  className={` absolute top-0.5 bottom-0 w-1/2 h-6 bg-[#1E293B] rounded-full opacity-65 ${ThemeColor
                    ? "translate-x-4 right-4 move-to-right"
                    : "left-0 move-to-left"
                    }`}
                ></span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SidebarNavigation;
